import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import PropTypes from 'prop-types';
import InvitationLinkButton from './InvitationLinkButton';

const InvitationLinkButtonPicker = ({ estatePlanMessageResource }) => {
  return pick(estatePlanMessageResource, {
    [fr.relationships.invitationLink.name]: (
      <InvitationLinkButton
        linkUrl={estatePlanMessageResource?.relationship(fr.relationships.invitationLink.name).link('related').url()}
        prompt={estatePlanMessageResource?.relationship(fr.relationships.invitationLink.name).meta('prompt')}
      />
    ),
  }, null);
};

InvitationLinkButtonPicker.propTypes = {
  estatePlanMessageResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default InvitationLinkButtonPicker;
